function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9998 2.00049C6.4766 2.00049 1.99982 6.47727 1.99982 12.0005C1.99982 17.5237 6.4766 22.0005 11.9998 22.0005C17.523 22.0005 21.9998 17.5237 21.9998 12.0005C21.9998 6.47727 17.523 2.00049 11.9998 2.00049ZM11.9998 3.50049C16.6946 3.50049 20.4998 7.3057 20.4998 12.0005C20.4998 16.6953 16.6946 20.5005 11.9998 20.5005C7.30503 20.5005 3.49982 16.6953 3.49982 12.0005C3.49982 7.3057 7.30503 3.50049 11.9998 3.50049ZM12.4046 7.74512C12.3549 7.37904 12.0411 7.09689 11.6614 7.09689C11.2472 7.09689 10.9114 7.43267 10.9114 7.84689V12.6939L10.9198 12.8056C10.9529 13.0257 11.0828 13.222 11.2772 13.338L15.0472 15.587L15.1381 15.6332C15.4779 15.7781 15.881 15.6532 16.0755 15.3271L16.1218 15.2362C16.2667 14.8964 16.1417 14.4933 15.8157 14.2988L12.411 12.267L12.4114 7.84689L12.4046 7.74512Z",
  fill: "#555770"
});

function SvgTimeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircle);
export default __webpack_public_path__ + "static/media/time-circle.d722a82f.svg";
export { ForwardRef as ReactComponent };